import { PaymentLabelTextHelper } from '../labelTextHelper/PaymentLabelTextHelper';
import { HeaderItem } from '../../model/HeaderItem';

// Fields excluded from the list view (not needed for import)
const excludedImportFieldList = ['paymentId', 'balanceType', 'dateCreateAt', 'dateModifyAt'];

export const PaymentHeaderHelper = {
    // Header items for LIST view (showing individual payment records with order info)
    getHeaderItems(): HeaderItem[] {
        return [
            { text: PaymentLabelTextHelper.getLabelText.paymentId, value: 'paymentId' },
            {
                text: PaymentLabelTextHelper.getLabelText.datePaymentOn,
                value: 'datePaymentOn',
                format: 'date'
            },
            { text: PaymentLabelTextHelper.getLabelText.orderNumber, value: 'orderNumber' },
            { text: PaymentLabelTextHelper.getLabelText.marketplaceCode, value: 'marketplaceCode' },
            { text: PaymentLabelTextHelper.getLabelText.paymentType, value: 'paymentType' },
            { text: PaymentLabelTextHelper.getLabelText.paymentAmount, value: 'paymentAmount' },
            { text: PaymentLabelTextHelper.getLabelText.paymentCurrencyCode, value: 'paymentCurrencyCode' },
            { text: PaymentLabelTextHelper.getLabelText.balanceType, value: 'balanceType' },
            { text: PaymentLabelTextHelper.getLabelText.description, value: 'description' },
            { text: PaymentLabelTextHelper.getLabelText.remarks, value: 'remarks' },
            {
                text: PaymentLabelTextHelper.getLabelText.dateCreateAt,
                value: 'dateCreateAt',
                format: 'datetime'
            },
            {
                text: PaymentLabelTextHelper.getLabelText.dateModifyAt,
                value: 'dateModifyAt',
                format: 'datetime'
            }
        ];
    },

    getDateTimePropertyList(): string[] {
        return this.getHeaderItems()
            .filter((item) => item.format === 'datetime')
            .map((item) => item.value);
    },

    getDatePropertyList(): string[] {
        return this.getHeaderItems()
            .filter((item) => item.format === 'date')
            .map((item) => item.value);
    },

    getActionHeaderItem(): HeaderItem {
        return { text: PaymentLabelTextHelper.getLabelText.action, value: 'action' };
    },

    getCsvHeader() {
        return [...this.getHeaderItems().map((item) => ({ key: item.value, text: item.text }))];
    },

    getHeaders() {
        return [...this.getHeaderItems(), this.getActionHeaderItem()];
    },

    getImportFields() {
        return this.getFilteredHeaderItems().reduce((acc, item) => {
            acc[item.value] = {
                required: false,
                label: item.text
            };
            return acc;
        }, {} as Record<string, { required: boolean; label: string }>);
    },

    getImportHeaders() {
        return this.getFilteredHeaderItems();
    },

    getFilteredHeaderItems() {
        return this.getHeaderItems().filter((header) => !excludedImportFieldList.includes(header.value));
    }
};
